<template>
  <TransitionGroup name="list" tag="div" class="impact-summary-container">
    <div
      v-for="(site, idx) in computedData.data.entries"
      :key="site.site.address"
      :class="['list-item', 'impact-block', { inactive: index !== idx && index !== -1 }]"
    >
      <div class="site-box">
        <SiteBlock :data="site.site" />
      </div>
      <ImpactSummary :data="site.impact" />
    </div>
  </TransitionGroup>
</template>

<script>
import Computing from '@/components/Analysis/Computing';
import SiteBlock from '@/components/Table/Site';
import ImpactSummary from '@/components/Map/Analysis/Summary/Impact';
export default {
  components: {
    SiteBlock,
    ImpactSummary,
  },

  mixins: [Computing],
  props: ['data', 'index', 'range'],

  computed: {
    computedData() {
      const { sites, filteredCollaboratorsCount, filteredCollaborators, currentTransportFilter } = this.data;

      const entries = sites.map(site => ({
        site: this.buildSiteBlock(site, filteredCollaborators, currentTransportFilter),
        impact: {
          site: site.details.impact,
          attributes: {
            total: filteredCollaboratorsCount,
          },
        },
      }));

      return {
        data: {
          entries,
        },
      };
    },
  },
};
</script>

<style lang="scss">
@use '@/styles/colors.scss';
.impact-summary-container.tv.dark {
  margin: auto;
  .impact-block {
    max-width: 320px;
    &.inactive {
      opacity: 0.2;
    }
  }
  .label-box .label-per {
    font-size: 70px;
    font-weight: 300;
  }
  .td {
    .poi {
      padding: 0;
      width: 58px;
      height: 86px;
    }
    .details {
      flex: 1;
      span {
        &.title {
          font-size: 28px;
        }
        &.address {
          font-size: 24px;
        }
      }
    }
  }
  .pie-chart-container {
    svg {
      width: 240px;
      height: auto;
    }
  }
  svg {
    path {
      stroke: #262631;
    }
  }
}
</style>
